import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subscription } from 'rxjs/internal/Subscription';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  skipWhile,
  take,
} from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { AppState, MyReturnActionTypes } from '@app/core/ngrx';

export interface Fruit {
  name: string;
}

@Component({
  selector: 'ecp-return-search',
  templateUrl: './return-search.component.html',
  styleUrls: ['./return-search.component.scss'],
})
export class ReturnSearchComponent implements OnInit, OnDestroy {
  private searchSub$: Subscription;
  public search$: BehaviorSubject<any> = new BehaviorSubject(null);

  // @select(['myreturn', 'list', 'brands'])
  public brands$: Observable<any>;

  // @select(['myreturn', 'selectedBrand'])
  public selectedBrand$: Observable<string>;

  public selectedBrand = '';

  /**
   * constructor
   * @param {NgRedux<AppState>} redux
   */

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.brands$ = this.store.pipe(
      select(state => state.myReturn.selectedReturn.brands),
    );
    this.selectedBrand$ = this.store.pipe(
      select(state => state.myReturn.selectedBrand),
    );
    this.brands$.pipe().subscribe(brands => {});

    this.searchSub$ = this.search$
      .pipe(
        skipWhile(event => !event),
        map(event => event.currentTarget.value),
        debounceTime(700),
        distinctUntilChanged(),
      )
      .subscribe(term => {
        this.store.dispatch({
          type: MyReturnActionTypes.SEARCH_MY_RETURN,
          payload: term,
        });
      });

    this.selectedBrand$.subscribe(selectedBrand => {
      console.log(selectedBrand);
      this.selectedBrand = selectedBrand;
    });
  }

  public onSelect(selectedBrand: string) {
    this.store.dispatch({
      type: MyReturnActionTypes.SET_MY_RETURN_SELECTED_BRAND,
      payload: selectedBrand,
    });
  }

  ngOnDestroy(): void {
    if (this.searchSub$) this.searchSub$.unsubscribe();
  }
}
